import React, { useState } from 'react';
import { MdOutlineDone } from 'react-icons/md';
import { GoCopy } from 'react-icons/go';

const SubscriptionItem = ({ subscription }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async (text) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }

      setIsCopied(true); 
      setTimeout(() => setIsCopied(false), 1000); 
    } catch (error) {
      console.error('Failed to copy text: ', error);
    }
  };

  return (
    <div className="bg-white border-b px-4 py-2 mb-2 dark:bg-gray-800 dark:border-gray-700 border-gray-200 flex justify-between items-center">
      <span className="font-medium text-gray-900 whitespace-nowrap dark:text-white">
        {subscription.name}
      </span>

      <div className="border text-xs border-[#e5eaf2] text-[#424242] rounded-md py-1 px-4 tracking-wider font-mono font-[500] flex items-center justify-between gap-4 w-fit">
        {subscription.license_key}
        <button
          onClick={() => handleCopy(subscription.license_key)}
          className="flex items-center justify-center"
          aria-label="Copy to clipboard"
        >
          <GoCopy
            className={`${
              isCopied ? 'opacity-0 hidden' : 'opacity-100 flex'
            } transition-all duration-300 cursor-pointer`}
          />
          <MdOutlineDone
            className={`${
              isCopied ? 'opacity-100 flex' : 'opacity-0 hidden'
            } transition-all duration-300 cursor-pointer`}
          />
        </button>
      </div>
      <span className="px-6 py-4">{subscription.valid_till}</span>
      {
        Array.isArray(subscription.meta) &&
        subscription.meta.find((meta) => meta.meta_name === 'download_link')?.meta_value ? (
          <a download className='hover:underline-offset-2 hover:underline' href={subscription.meta.find((meta) => meta.meta_name === 'download_link').meta_value} target="_blank" rel="noopener noreferrer">
            Download
          </a>
        ) : null
      }
    </div>
  );
};

export default SubscriptionItem;